import MyGradesList from "./MyGrades/MyGradesList";
import MyGradesExport from "./MyGrades/MyGradesExport";
import {
  Container,
  Button,
  Table,
  Offcanvas,
  Figure,
  Alert,
} from "react-bootstrap";
import { useState } from "react";
import { Link } from "react-router-dom";
import { HelpLinks } from "./Utils";

function Home(props) {
  const ls = require("localstorage-ttl");
  const { isLoggedIn } = props;

  const [showHelp, setShowHelp] = useState(false);
  const handleCloseHelp = () => setShowHelp(false);
  const handleShowHelp = () => setShowHelp(true);

  const displayFormat = "DD/MM/YYYY";
  var moment = require("moment");

  function getCache(key) {
    const keyValue = ls.get(key);
    if (keyValue && keyValue != null) return JSON.parse(keyValue);
    return null;
  }

  const usuario = getCache("userData");
  const examenes = getCache("userExams");

  const isDanNoAikikai = usuario ? usuario.isDanNoAikikai : false;

  if (!isLoggedIn || !usuario)
    return (
      <Container className="p-3 mb-4 bg-light rounded-3">
        <h4>Bienvenido al Carnet Digital de la Federacion Aikikai Argentina</h4>
        <br />
        <p>
          <Link to="/signin">INGRESAR</Link> para ver sus datos
        </p>
        <HelpLinks />
      </Container>
    );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      {examenes.length > 0 ? (
        <>
          <p>Para descargar e imprimir el carnet utilice el boton</p>
          <Button
            variant="success"
            style={{ width: "300px", marginBottom: "20px", fontSize: "25px" }}
            onClick={() => MyGradesExport(usuario, examenes)}
          >
            GENERAR CARNET PDF
          </Button>
          <hr />
        </>
      ) : (
        <></>
      )}
      <p style={{ marginTop: "30px" }}>
        Estos son los datos registrados en el carnet digital.
        <br />
        Para cambios o correcciones enviar un email a{" "}
        <a href="mailto:faadatoscarnet@gmail.com">
          faadatoscarnet@gmail.com
        </a>{" "}
        indicando DNI y cambio a realizar
      </p>
      <h1>
        {usuario.lastname}, {usuario.name}
      </h1>
      <Table
        bordered
        className="bg-white"
        size="sm"
        style={{ maxWidth: "600px", margin: "0 auto 30px auto" }}
      >
        <tbody>
          <tr>
            <td>Documento</td>
            <td>{usuario.docNumber}</td>
          </tr>
          <tr>
            <td>Fecha Nac.</td>
            <td>{moment(usuario.birthDate).format(displayFormat)}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{usuario.email}</td>
          </tr>
          <tr>
            <td>Fecha Ingreso</td>
            <td>{moment(usuario.startDate).format(displayFormat)}</td>
          </tr>
        </tbody>
      </Table>
      {examenes.length > 0 ? (
        <>
          <h2>Mis Graduaciones</h2>

          <Alert
            show={isDanNoAikikai}
            variant="warning"
            style={{
              margin: "0 auto 10px",
              maxWidth: "600px",
            }}
          >
            <p>
              Se detectaron examenes de DAN aprobados sin los datos de la
              Yudansha. Si tenés esa infomación actualizada mirá el instructivo
              para informarnos los datos
            </p>
            <Button onClick={handleShowHelp} variant="secondary">
              VER INSTRUCTIVO
            </Button>
          </Alert>

          {examenes.map((data) => (
            <MyGradesList exam={data} key={data.id} />
          ))}
        </>
      ) : (
        <h3>No hay graduaciones.</h3>
      )}
      <Offcanvas show={showHelp} onHide={handleCloseHelp}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Informar Datos de la Yudansha</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p>
            Envianos por mail a{" "}
            <a href="mailto:faadatoscarnet@gmail.com">
              faadatoscarnet@gmail.com
            </a>{" "}
            los datos ó una foto de la segunda hoja de la Yudansha ó foto del
            diploma.
          </p>
          <Figure>
            <Figure.Image alt="yudansha" src="yudansha.jpg" />
            <Figure.Caption>
              Yudansha: debe verse la graduacion, Registered No. y Date
            </Figure.Caption>
          </Figure>
          <br />
          <Figure>
            <Figure.Image alt="diploma" src="diploma.jpg" />
            <Figure.Caption>
              Diploma: deben verse todos los datos
            </Figure.Caption>
          </Figure>
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}
export default Home;
